// این فایل بعد از پرداخت بلیط و بعد تکمیل مشخصات نمایش داده میشود و چاپ اش هم شماره صندلی و نام خریدار را نمایش میدهد
import React from "react";
import { useScreenshot } from "use-react-screenshot";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import PrintComponents from "react-print-components";
import QRCode from "react-qr-code";
import { useHistory } from "react-router-dom";
import ticketFooter from "../../../../ebusHomePics/ticket-footer.png";
import { useMediaQuery } from "react-responsive";
import { DateTimeHandler } from "./../../../utils/Helper";
import {
  getTicketDetails,
  getAllFavPassengers,
} from "../pages/widgets/components/cruds";
import { useDispatch } from "react-redux";
import { actions } from "../../SearchPage/_redux/searchRedux";
import { getUserTravels } from "./../../Account/_redux/accountCrud"
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const AfterGatewayTicketDetails = (props) => {
  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));
  const { state } = useSelector((state) => ({
    state: state.search,
  }));

  const dispatch = useDispatch();

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const history = useHistory();


  const timeManager = (time) => {
    if (time) {
      const splittedTime = time
        .split("T")[1]
        .split(".")[0]
        .split(":");
      return `${splittedTime[0]}:${splittedTime[1]}`;
    }
  };

  const splittedURL = history.location.pathname.split("/");
  const [apiStats, setApiStats] = React.useState(0);
  const [information, setInformation] = React.useState(null);

  const handleDownloadPdf = async () => {
    const canvas = await html2canvas(document.querySelector('#pdf'));
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (imgProperties.height * pdfWidth) / imgProperties.width;

    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('ticket.pdf');
  };

  React.useEffect(() => {
    const params = {
      travelTicketId: +splittedURL[2],
    };
    const userCookies = JSON.parse(window.localStorage.getItem("userInformation"))
    getUserTravels(userCookies, params)
      .then((res) => {
        setInformation(res.data)
      })
      .catch((error) => {
        console.log("error", error)
      });
  }, []);

  // const persianDateHandler = () => {
  //   const urlDate = information?.purchaseTime;
  //   let dateOptions = {
  //     weekday: "long",
  //     year: "numeric",
  //     month: "long",
  //     day: "numeric",
  //   };
  //   const persianDate = new Date(urlDate).toLocaleDateString(
  //     "fa-Ir",
  //     dateOptions
  //   );

  //   const day = persianDate.split(",")[1];
  //   const monthAnddate = persianDate.split(",")[0].split(" ");

  //   const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

  //   return mixed;
  // };

  return (
    <>
      {information?.travelReports ?
        information.travelReports.map((el, index) => {
          return (
            <>
              <div
                className="mx-auto w-100 col-12 col-md-10 border border-secondary p-7 bg-white my-10" id="pdf"
                style={{ height: "fit-content", width: "15cm", borderRadius: "13px" }}
              >
                <div
                  className="row justify-content-center mb-1 mb-md-15"
                  style={{ color: "#6dd06d" }}
                >
                  <h1>
                    <b>بلیط های صادر شده</b>
                  </h1>
                </div>

                <div className="d-flex mt-5  mb-0 mb-md-10">
                  <div className="col-lg-9 col-md-8  mb-0 mb-md-12">
                    <div className="col-md-12 d-block d-lg-flex align-items-center">
                      <p className="col-md-4 col-lg-5 col-11">
                        {" "}
                        <span style={{ fontSize: 18 }}>
                          <b>مبدا: </b>
                        </span>
                        <span
                          style={{
                            fontSize: 17,
                            marginRight: 5,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.ticketSource.title ? el.ticketSource.title : null}
                        </span>
                      </p>
                      <div className="d-lg-block w-100 col-6 col-md-4 col-lg-3"></div>
                      <p className="col-11 col-md-4 col-lg-6">
                        <span style={{ fontSize: 18 }}>
                          <b>مقصد: </b>
                        </span>
                        <span
                          style={{
                            fontSize: 17,
                            marginRight: 5,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.ticketDest.title ? el.ticketDest.title : null}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-12 d-block d-lg-flex mt-5 justify-content-between">

                      <p className="col-11 col-md-5">
                        {" "}
                        <span style={{ fontSize: 17 }}>
                          <b>ساعت حرکت:</b>{" "}
                        </span>
                        <span
                          style={{
                            fontSize: 16,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.Travel.departureDatetime
                            ? DateTimeHandler(el.Travel.departureDatetime).time
                            : null}
                        </span>
                      </p>

                      <div className="d-lg-block w-100 col-6 col-md-4 col-lg-3"></div>

                      <p className="col-12 col-md-6">
                        {" "}
                        <span>
                          <b
                            style={{ fontSize: 18 }}
                            className="white-nowrap"
                          >
                            تاریخ حرکت:
                          </b>
                        </span>
                        <span
                          style={{
                            fontSize: 17,
                            marginRight: 5,
                          }}
                        >
                          {el.Travel.departureDatetime
                            ? DateTimeHandler(el.Travel.departureDatetime).date
                            : null}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-12 d-block d-lg-flex mt-5 justify-content-between">
                      <div className="col-md-8">
                        <span className="font-16">
                          <b>نام مسافر/مسافرین: </b>
                        </span>
                        <span
                          className="font-16 white-nowrap"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.TravelTicketDetails ?
                            el.TravelTicketDetails.map((ticket, index) =>
                            (
                              `${ticket.passengerFirstName} ${" "} ${ticket.passengerLastName}
                              ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                            `
                            ))
                            : null}
                        </span>
                      </div>

                      <div className="col-md-5 mt-5 mt-lg-0">
                        <span className="font-16">
                          <b>شماره صندلی: </b>
                        </span>
                        <span
                          className="font-16 white-nowrap"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.TravelTicketDetails ?
                            el.TravelTicketDetails.map((ticket, index) =>
                            (
                              `${ticket.seatNumber} 
                              ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                            `
                            ))
                            : null}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-12 d-block d-lg-flex mt-5 justify-content-between">
                      <div className="col-md-8 mt-5">
                        <span className="font-16">
                          <b>شماره سفارش: </b>
                        </span>
                        <span
                          className="font-16 white-nowrap"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.id ? el.id : null}
                        </span>
                      </div>

                      <div className="col-md-5 mt-5">
                        <span className="font-16">
                          <b>قیمت: </b>
                        </span>
                        <span
                          className="font-16 white-nowrap"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span
                            className="white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                              textDecoration: "line-through"
                            }}
                          >
                            {el.Travel ? el.Travel.basePrice.toLocaleString('ar-EG') : null}
                          </span>
                          <span> - </span>
                          <span
                            className=" white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            {el ? el.orginalPrice.toLocaleString('ar-EG') : null}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-4 d-none d-md-block p-3">
                    {el.qrCode ? (
                      <QRCode value={el.qrCode} size="200" />
                    ) : null}
                  </div>
                </div>
                <img src={ticketFooter} className="w-100" />
              </div>

              <div className="row w-100 col-12 mt-10 px-md-30 mx-0">
                <div className="col-12 col-md-4 my-2 p-1" style={{ height: "4rem" }}>
                  <Button
                    className="w-100 h-100"
                    style={{
                      border: "0.5px solid #6dd06d",
                      borderRadius: "13px",
                    }}
                    onClick={() => {
                      history.push("/");
                    }}
                  >
                    <h6
                      className="mx-auto my-auto"
                      style={{
                        color: "#6dd06d",
                      }}
                    >
                      {" "}
                      بازگشت به صفحه اصلی
                    </h6>
                  </Button>
                </div>
                <div className="col-12 col-md-4 my-2 p-1" style={{ height: "4rem" }}>
                  <PrintComponents
                    trigger={
                      <Button
                        className="w-100 h-100"
                        style={{
                          backgroundColor: "#6dd06d",
                          border: "0.5px solid white",
                          borderRadius: "13px",
                        }}
                      >
                        <h6 className="ms-auto my-auto text-white"> چاپ بلیط</h6>
                      </Button>
                    }
                  >

                    <div
                      className="mx-auto w-75 border border-dark px-7"
                      style={{ height: "20cm", width: "15cm" }}
                    >
                      <div
                        className="row justify-content-between"
                        style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
                      >
                        <h1>
                          {" "}
                          <b>مبدا:</b> {el.ticketSource.title ? el.ticketSource.title : null}
                        </h1>
                        <h1>
                          {" "}
                          <b>مقصد:</b>
                          {el.ticketDest.title ? el.ticketDest.title : null}
                        </h1>
                      </div>
                      <div
                        className="line w-100"
                        style={{
                          borderBottom: "4px solid black",
                          marginBlock: "2rem",
                        }}
                      ></div>
                      <div
                        className="row justify-content-between my-5 "
                        style={{ marginInline: "25px", marginBlock: "3rem 1.5rem" }}
                      >
                        <h1>
                          <b>تاریخ:</b>
                          <span style={{ marginRight: 5 }}>
                            {el.Travel.departureDatetime
                              ? DateTimeHandler(el.Travel.departureDatetime).date
                              : null}
                          </span>
                        </h1>
                        <h1>
                          <b>ساعت حرکت:</b>
                          <span style={{ marginRight: 5 }}>
                            {el.Travel.departureDatetime
                              ? DateTimeHandler(el.Travel.departureDatetime).time
                              : null}
                          </span>
                        </h1>
                      </div>
                      <div
                        className="line w-100"
                        style={{
                          borderBottom: "4px solid black",
                          marginBlock: "2rem",
                        }}
                      ></div>

                      <div
                        className="row mb-20 mb-25"
                        style={{ marginRight: "25px", marginLeft: "12px" }}
                      >

                        <div className="col-md-6 row d-lg-flex mt-1 justify-content-between">
                          <div
                            className="col-md-12 mt-3 mt-lg-0"
                            style={{ fontSize: "23px" }}>
                            <span >
                              <b>شماره سفارش: </b>
                            </span>
                            <span
                              className="white-nowrap"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {el.id ? el.id : null}
                            </span>
                          </div>

                          <div
                            className="col-md-12 mt-3 mt-lg-0"
                            style={{ fontSize: "22px" }}>
                            <span >
                              <b>نام مسافر/مسافرین: </b>
                            </span>
                            <span
                              className="white-nowrap"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {el.TravelTicketDetails ?
                                el.TravelTicketDetails.map((ticket, index) =>
                                (
                                  `${ticket.passengerFirstName} ${" "} ${ticket.passengerLastName}
                              ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                            `
                                ))
                                : null}
                            </span>
                          </div>

                          <div
                            className="col-md-12 mt-3 mt-lg-0"
                            style={{ fontSize: "23px" }}>
                            <span>
                              <b>شماره صندلی: </b>
                            </span>
                            <span
                              className=" white-nowrap"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {el.TravelTicketDetails ?
                                el.TravelTicketDetails.map((ticket, index) =>
                                (
                                  `${ticket.seatNumber} 
                            ${index === el.TravelTicketDetails.length - 1 ? " " : " , "}
                          `
                                ))
                                : null}
                            </span>
                          </div>

                          <div
                            className="col-md-12 mt-3 mt-lg-0"
                            style={{ fontSize: "23px" }}>
                            <span>
                              <b>قیمت: </b>
                            </span>
                            <span
                              className="white-nowrap"
                              style={{
                                whiteSpace: "nowrap",
                                textDecoration: "line-through"
                              }}
                            >
                              {el.Travel ? el.Travel.basePrice.toLocaleString('ar-EG') : null}
                            </span>
                            <span> - </span>
                            <span
                              className=" white-nowrap"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {el ? el.orginalPrice.toLocaleString('ar-EG') : null}
                            </span>
                          </div>
                        </div>

                        <div className="col-6 w-100" style={{ paddingBlock: "2rem" }}>
                          {el.qrCode ?
                            <QRCode
                              value={el.qrCode}
                              className="w-100"
                              size={isTabletOrMobile ? "120" : "150"}
                            />
                            : null}
                        </div>
                      </div>
                      <img src={ticketFooter} className="w-100" />
                    </div>
                  </PrintComponents>
                  
                </div>
                <div className="col-12 col-md-4 my-2 p-1" style={{ height: "4rem" }}>
                <Button
                    className="w-100 h-100"
                    style={{
                      backgroundColor: "#6dd06d",
                      border: "0.5px solid white",
                      borderRadius: "13px",
                    }}
                    onClick={handleDownloadPdf}
                  >
                    <h6 className="ms-auto my-auto text-white"> دانلود بلیط</h6>
                  </Button>
                </div>

              </div>
              <div className="col-1"></div>
            </>
          )
        }) : null
      }
    </>
  );
};

export default AfterGatewayTicketDetails;
